// export const  post_id = '9263'
// export const  base_url="https://b.coderworld.xyz"

export function getPostId(){
    let href = window.location.href;
    let hrefArray = href.split("/");
    let postArray= hrefArray[hrefArray.length-1].split(".");
    let post_id = postArray[0];
    // console.log(post_id);
    return post_id;
}


export function base_url(){
    const hostname = window.location.hostname;
    const base_url = "https://" + hostname;
    return base_url
}
export function baseUrl(){
    const hostname = window.location.hostname;
    const base_url = "https://" + hostname;
    return base_url
}

export function api_base_url(){
    const hostname = window.location.hostname;
    const base_url = "https://" + hostname;
    return base_url
}

export function isHostPage(){
    // const hostname = window.location.hostname;
    const base_url = window.location.href;
    // console.log(base_url)
    if(base_url=="https://www.bee.com" || base_url=="https://b.coderworld.xyz" ){
        return true;
    }else{
        return false;
    }
}


export function hostHref(){
    const base_url = window.location.href;
    return encodeURIComponent(base_url);
}

export const  todayNmf =() => {
    // localStorage.setItem(key, value);
    // localStorage.getItem('uname')
    var today = new Date();
    var DD = String(today.getDate()).padStart(2, '0');
    var MM = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear(); //
    const todayStr = yyyy + '-' + MM + '-' + DD;
    // console.log(todayStr);
    return todayStr;
  }


export const TGLogin = () => {
    window.location.href = 'https://oauth.telegram.org/auth?bot_id=7530752537&origin=https%3A%2F%2Fb.coderworld.xyz&embed=1&request_access=write&return_to=https%3A%2F%2Fb.coderworld.xyz%2F%23%2F'
  };
  

  export const openAi_key="sk-NXLnPxgh5IxGn7KmPpex9d2tywb03va0A_39Wj4AVIT3BlbkFJxeOf93uqqBZIzNRGSumMCPC5JAJothCEp_9ptkWP4A"
  export const openAi_engine="gpt-4o"
  
  
  // export const twitter_auth_url="https://x.com/i/oauth2/authorize?response_type=code&client_id=LVpFX0NseG9sa1E1WjVmV3o4aW46MTpjaQ&redirect_uri=https://b.coderworld.xyz/&scope=tweet.read%20users.read%20offline.access&state=state&code_challenge=challenge&code_challenge_method=plain"
  
  // export const test_twitter_auth_url="https://x.com/i/oauth2/authorize?response_type=code&client_id=LVpFX0NseG9sa1E1WjVmV3o4aW46MTpjaQ&redirect_uri=https://b.coderworld.xyz&scope=tweet.read%20users.read%20offline.access&state=state&code_challenge=challenge&code_challenge_method=plain"
  
  export const twitter_auth_url="https://x.com/i/oauth2/authorize?response_type=code&client_id=LVpFX0NseG9sa1E1WjVmV3o4aW46MTpjaQ&redirect_uri=https://www.bee.com&scope=tweet.read%20users.read%20offline.access&state=state&code_challenge=challenge&code_challenge_method=plain"
  
  export const test_twitter_auth_url="https://x.com/i/oauth2/authorize?response_type=code&client_id=LVpFX0NseG9sa1E1WjVmV3o4aW46MTpjaQ&redirect_uri=https://www.bee.com&scope=tweet.read%20users.read%20offline.access&state=state&code_challenge=challenge&code_challenge_method=plain"
  
  
  export const twitter_client_id="TlJqaGtkTTZxNDVsaHNYLXZHYVQ6MTpjaQ";
  // export const twitter_redirect_uri="https://b.coderworld.xyz";
  export const twitter_redirect_uri="https://www.bee.com";
  export const twitter_Client_Secret="_d-gXcy1X9612JfhwWKUZa1bAL0kDG7NwCg_2Snj1X8GzfgW52";
  
  export const twitter_API_key="9LhUh6wnuh2RMtoqsCMlZrDan";
  export const twitter_API_Secret="DulmuGzuh6OG4xgjUgFlxI8Wft49li7ZftWQv48YxGJ2ghANWa";
  
  // export const discord_auth_url="https://discord.com/oauth2/authorize?client_id=1280785345461489695&response_type=code&redirect_uri=https%3A%2F%2Fb.coderworld.xyz&scope=email+identify"
  export const discord_auth_url="https://discord.com/oauth2/authorize?client_id=1280785345461489695&response_type=code&redirect_uri=https%3A%2F%2Fwww.bee.com&scope=email+identify"
  
  export const tgBotName ="beetasktestbot";  